var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("database-management-modal", {
    ref: "modal",
    attrs: { element: _vm.category },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              { class: _vm.hasErrorClass(_vm.$v.category.name, "form-group") },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("* Name"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.category.name.$model,
                      expression: "$v.category.name.$model",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    name: "name",
                    type: "text",
                    placeholder: "Category Name",
                  },
                  domProps: { value: _vm.$v.category.name.$model },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.$v.category.name,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: { field: _vm.$v.category.name, label: "Name" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: _vm.hasErrorClass(
                  _vm.$v.category.currency,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Currency"),
                ]),
                _vm._v(" "),
                _c("selectize", {
                  staticClass: "selectize selectize-single form-control",
                  attrs: {
                    name: "currency",
                    options: _vm.currencyFieldOptions,
                    "disable-delete": true,
                  },
                  model: {
                    value: _vm.$v.category.currency.$model,
                    callback: function ($$v) {
                      _vm.$set(_vm.$v.category.currency, "$model", $$v)
                    },
                    expression: "$v.category.currency.$model",
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: { field: _vm.$v.category.currency, label: "Currency" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: _vm.hasErrorClass(
                  _vm.$v.category.hide_budget,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("* Hide Budget"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "checkbox checkbox-primary" }, [
                  _c(
                    "div",
                    { staticClass: "input-group-checkbox" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.category.hide_budget.$model,
                            expression: "$v.category.hide_budget.$model",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "hide_budget",
                          name: "hideBudget",
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.$v.category.hide_budget.$model
                          )
                            ? _vm._i(_vm.$v.category.hide_budget.$model, null) >
                              -1
                            : _vm.$v.category.hide_budget.$model,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.$v.category.hide_budget.$model,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.$v.category.hide_budget,
                                    "$model",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.$v.category.hide_budget,
                                    "$model",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.$v.category.hide_budget,
                                "$model",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "hide_budget" } }, [
                        _vm._v(
                          "\n            Hide budget from non-admin users when they view an appearance with this category\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("vuelidate-help", {
                        attrs: {
                          field: _vm.$v.category.hide_budget,
                          label: "Hide Budget",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "ladda-button",
              {
                staticClass: "btn btn-lg btn-primary pull-right",
                attrs: {
                  click: _vm.saveCategory,
                  type: "button",
                  "data-dismiss": "modal",
                },
              },
              [_c("i", { staticClass: "fa fa-check" }), _vm._v(" Save")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }